export class CKEditorInstanceManager {
	private static instance: CKEditorInstanceManager | null = null;
	private editorInstance: any = null;

	private constructor() {}

	static getInstance(): CKEditorInstanceManager {
		if (!CKEditorInstanceManager.instance) {
			CKEditorInstanceManager.instance = new CKEditorInstanceManager();
		}
		return CKEditorInstanceManager.instance;
	}

	register(editor: any): void {
		this.editorInstance = editor;
	}

	unregister(): void {
		this.editorInstance = null;
	}

	getEditor(): any {
		return this.editorInstance;
	}

	isReady(): boolean {
		return !!this.editorInstance;
	}

	getData(): string {
		if (!this.editorInstance) {
			console.warn("CKEditor instance not available");
			return "";
		}
		return this.editorInstance.getData();
	}

	executeCommand(commandName: string, options?: any): void {
		if (!this.editorInstance) {
			console.warn("CKEditor instance not available");
			return;
		}
		const command = this.editorInstance.commands.get(commandName);
		if (command) {
			this.editorInstance.execute(commandName, options);
		}
	}

	getInputFields(): Array<{
		element: HTMLElement;
		recipientId: string | undefined;
		fieldId: string | undefined;
		title: string | undefined;
	}> {
		if (!this.editorInstance) {
			console.warn("CKEditor instance not available");
			return [];
		}

		const inputFields: Array<{
			element: HTMLElement;
			recipientId: string | undefined;
			fieldId: string | undefined;
			title: string | undefined;
		}> = [];

		const editorData = this.editorInstance.getData();

		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = editorData;

		const ckInputFields = tempDiv.querySelectorAll(
			'[class="ck-input-field"]'
		);

		ckInputFields.forEach(field => {
			const htmlElement = field as HTMLElement;
			inputFields.push({
				element: htmlElement,
				recipientId: htmlElement.dataset.fieldAssignee,
				fieldId: htmlElement.dataset.fieldId,
				title: htmlElement.getAttribute("title") || undefined
			});
		});

		return inputFields;
	}

	getUnassignedInputFields(signers: Array<{ id: string }> | undefined): {
		hasUnassigned: boolean;
		unassignedFields: Array<{
			element: HTMLElement;
			recipientId: string | undefined;
			fieldId: string | undefined;
			title: string | undefined;
		}>;
	} {
		const allInputFields = this.getInputFields();

		if (!signers || signers.length === 0) {
			return {
				hasUnassigned: allInputFields.length > 0,
				unassignedFields: allInputFields
			};
		}

		const unassignedFields = allInputFields.filter(field => {
			const recipientId = field.recipientId;
			if (!recipientId || recipientId === "") {
				return true;
			}
			return !signers.some(signer => signer.id === recipientId);
		});

		return {
			hasUnassigned: unassignedFields.length > 0,
			unassignedFields
		};
	}
}

export default CKEditorInstanceManager;
